let artistSearch=document.getElementById('artistSearch');
let artistSearchString;
let lastArtistStringLogged;
let keyUpTimeout;

artistSearch.addEventListener('keyup', function() {
  let artistSearchString = this.value.trim().toLowerCase();
  artistSearchString = replaceArtistAlternates(artistSearchString);
  
  console.log(artistSearchString);

  if (keyUpTimeout!=undefined) {
    clearTimeout(keyUpTimeout);
  }
  
  keyUpTimeout=setTimeout(function() {
    if (artistSearchString!='' && artistSearchString!=lastArtistStringLogged) {
      
      postData("http://stage.store-warnermusiccanada-com.nds.acquia-psi.com/artist_search.php", { artist: artistSearchString }).then((data) => {
        console.log(data); // JSON data parsed by `data.json()` call
      });
      
      lastArtistStringLogged=artistSearchString;
    }
  }, 1000);    

  let ul = document.querySelector('.collections-grid');
  let liItems = ul.querySelectorAll('li');

  liItems.forEach((item) => {
    let h3 = item.querySelector('h3.collection-grid__title');
    let a = h3.querySelector('a');
    let artistName = a.innerHTML.trim().toLowerCase();
    
    if (artistName.includes(artistSearchString)) {
      item.style.display = "list-item";
    } else {
      item.style.display = "none";
    }
  });

});

async function postData(url = "", data = {}) {
  // Default options are marked with *
  const response = await fetch(url, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "no-cors", // no-cors, *cors, same-origin
    cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
    headers: {
      "Content-Type": "application/json",
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    redirect: "follow", // manual, *follow, error
    referrerPolicy: "origin", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    body: JSON.stringify(data), // body data type must match "Content-Type" header
  });
  return response.json(); // parses JSON response into native JavaScript objects
}

function replaceArtistAlternates(searchTerm) {
   const alternates = {
       'rhcp': 'red hot chili peppers',       
       'rchp': 'red hot chili peppers',       
       'csny': 'crosby, stills, nash',       
       'csn': 'crosby, stills, nash',
       'stp': 'stone temple pilots',
       'heartbreakers': 'tom petty',
       // add more mappings as needed
   };

   return searchTerm
       .toLowerCase()
       .split(' ')
       .map(word => alternates[word] || word)
       .join(' ');
}
